import { ActivatedRoute, Router } from '@angular/router';
import { Component, OnInit, OnDestroy } from '@angular/core';
import { AppState } from '../../reducers';
import { Store, select, Action } from '@ngrx/store';
import { AfterLoginRequested } from '../store/session.actions';
import { Subscription } from 'rxjs';
import { environment } from 'src/environments/environment';

@Component({
	selector: 'after-login',
	templateUrl: './after-login.component.html',
	styleUrls: ['./after-login.component.css']
})
export class AfterLoginComponent implements OnInit, OnDestroy {

	private readonly ID_PERSONA_INSITUCIONAL: string = 'ipi';
	private readonly TOKEN: string = 'token';
	private subscription: Subscription;

	constructor( private router: Router, private route: ActivatedRoute, private store: Store<AppState> ) {
	}

	ngOnInit(): void {
		this.subscription = this.route.queryParams.subscribe(
			params => {
				let idPersonaInstitucional: string = params[ this.ID_PERSONA_INSITUCIONAL ];
				let actionParam: any = idPersonaInstitucional != null? { idPersonaInstitucional, useTokenAcceso: false }: { useTokenAcceso: true };

				if( actionParam != null ) {
					this.store.dispatch( new AfterLoginRequested( actionParam ) );
					this.router.navigateByUrl( '/sesion/inicio', { replaceUrl: true } );
				}
			}
		);
	}

	ngOnDestroy(): void {
		if( this.subscription )
			this.subscription.unsubscribe();
	}

	private getTokenFromCookie( cookieName: string ): string {
		let token: string = null;
		let nameIndex: number = document.cookie.indexOf( cookieName );
		if( nameIndex > -1 ) {
			let keyValue: string = document.cookie.substring( nameIndex );
			let equalIndex: number = keyValue.indexOf( '=' );
			let sepIndex: number = keyValue.indexOf( ';' );
			if( equalIndex > -1 )
				token = sepIndex > -1? keyValue.substring( ++equalIndex, sepIndex ): keyValue.substring( ++equalIndex );
		}
		return token;
	}




/*
 * private methods
 */	

	private setCookie( { name, value, domain = null, path = '/', secure = false, expires = null } ) {
		let cookieStr: string = `${encodeURIComponent(name)}=${encodeURIComponent(value)}`;

		if( path )
			cookieStr += `; path=${path}`;
		if( domain )
			cookieStr += `; domain=${domain}`;
		if( expires instanceof Date )
			cookieStr += `; expires=${expires.toUTCString()}`;
		if( secure )
			cookieStr += `; secure`;
	  
		document.cookie = cookieStr;
	}

}
